export default __webpack_public_path__ + "static/media/large-circle.497b4a89.svg";